const useHnConverter = (hn) => {
    const convertHN = () => {
        const hnParts = hn.toString().split('');
        const lastFive = hnParts.slice(-5).join('');
        const firstPart = hnParts.slice(0, -5).join('');

        let firstPartWithoutZeros = firstPart;
        if (firstPart) {
            firstPartWithoutZeros = firstPart.replace(/^0+/, '');
            if (firstPartWithoutZeros && firstPartWithoutZeros !== '0') {
                firstPartWithoutZeros = firstPartWithoutZeros.replace(/0+$/, '');
                if (!firstPartWithoutZeros) {
                    firstPartWithoutZeros = parseInt(firstPart, 10).toString();
                }
            } else if (firstPartWithoutZeros === '0') {
                firstPartWithoutZeros = '0';
            } else {
                firstPartWithoutZeros = parseInt(firstPart, 10).toString();
            }
        }

        const converted = lastFive + '/' + firstPartWithoutZeros;
        return converted;
    };

    const revertHN = () => {
        const [lastFive, firstPart] = hn.split('/');
        // pad firstPart ให้เป็น 4 หลัก (เติม trailing zeros) เช่น "66" -> "6600"
        // เพราะเวลา convertHN เราได้ลบ trailing zeros ออกไปแล้ว
        const paddedFirstPart = firstPart.padEnd(4, '0');
        // lastFive ไม่ต้อง pad เพราะมันคือ 5 หลักอยู่แล้ว
        const revertedHN = paddedFirstPart + lastFive;
        return revertedHN;
    };

    return { convertHN, revertHN };
};

export default useHnConverter;
